export const Blue = '/images/body_back2.png'
export const Building = '/images/body_wrap_back.png'
export const ContentBackground = '/images/con_back.jpg'
